import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { useTheme } from '@material-ui/core/styles';
import { readableHeading } from '../readablePalette';

const ClosingPitch = () => {
  const theme = useTheme();
  const h = readableHeading(theme);

  return (
    <Box marginY={4}>
      <Typography variant="overline" sx={{ fontWeight: 700, letterSpacing: '0.14em', color: theme.palette.secondary.main }}>
        Lo que esta alianza comunica
      </Typography>
      <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 700, fontFamily: 'Georgia, serif', color: h, mt: 0.5 }}>
        Un compromiso que la audiencia reconoce
      </Typography>
      <Box
        component="blockquote"
        sx={{
          m: 0,
          mt: 2,
          pl: 3,
          borderLeft: `4px solid ${theme.palette.secondary.main}`,
          fontStyle: 'italic',
        }}
      >
        <Typography variant="h6" component="p" color="textPrimary" sx={{ fontWeight: 500, lineHeight: 1.65 }}>
          Patrocinar <em>Legalmente en Familia</em> permite a Hoet & Partners demostrar que invierte activamente en los
          valores fundamentales y la protección legal de la familia venezolana. No es solo una pauta; es ocupar un espacio
          de autoridad donde la propiedad intelectual se convierte en una herramienta de seguridad para el futuro de
          nuestros hijos en el entorno digital.
        </Typography>
      </Box>
    </Box>
  );
};

export default ClosingPitch;
